import { Button, DialogTrigger, ModalOverlay, Modal, Dialog } from 'react-aria-components'
import FeedbackWidget from './FeedbackWidget.js'

// Always-available feedback launcher, pinned to the bottom-right of the viewport.
//
// It's built as a React Aria overlay (not a plain div) on purpose: the story
// scenes are React Aria Modals that *contain* focus, so a form living outside
// that modal can't hold keyboard focus and clicks fall through to the scene's
// scrollbar. Opening our own Modal pushes it to the top of React Aria's overlay
// stack, which suspends the scene modal's focus trap — so the textarea is
// focusable and this panel captures its own scroll, over anything on screen.
export default function FloatingFeedback () {
  return (
    <DialogTrigger>
      <Button
        aria-label='Feedback'
        className='fixed bottom-4 left-4 z-[2000] px-3 py-2 bg-green-200 border-solid border rounded-full outline-black shadow-lg text-sm font-mono hover:bg-green-300'
      >
        💬 Feedback
      </Button>

      <ModalOverlay isDismissable className='fixed inset-0 z-[2000] flex items-end justify-start p-4'>
        <Modal className='w-72 max-w-[85vw] bg-white p-3 border-solid border rounded-sm shadow-lg font-mono'>
          <Dialog className='outline-none'>
            {({ close }) => (
              <>
                <div className='mb-1 flex items-center justify-between'>
                  <span className='text-sm text-gray-600'>Send feedback</span>
                  <Button
                    onPress={close}
                    aria-label='Close feedback'
                    className='px-1 leading-none text-gray-500 hover:text-black'
                  >
                    ✕
                  </Button>
                </div>
                {/* Leave the "Thanks!" up briefly, then close (which unmounts
                    the form, resetting it for next time). */}
                <FeedbackWidget onSubmitted={() => setTimeout(close, 1500)} />
              </>
            )}
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  )
}
